export const NIT_VW = '901666689';
export const NIT_BATERICARS = '900973544';
export const NIT_EUROMOTOR = '902048314';
export const NIT_HYS = '800249945';


// WEBPACK FOOTER //
// ./src/util/subscriberConstants.js